import Link from "next/link";

const BreadCrumb = ({ title, text, actionButtonText, actionButtonLink }) => {
  return (
    <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="breadcrumb-inner text-center">
              <h2 className="title">{title}</h2>
              <ul className="page-list">
                <li className="rbt-breadcrumb-item">
                  <Link href="/">Home</Link>
                </li>
                <li>
                  <div className="icon-right">
                    <i className="feather-chevron-right"></i>
                  </div>
                </li>
                <li className="rbt-breadcrumb-item active">{text}</li>
              </ul>
              {actionButtonText && <Link 
                className="rbt-moderbt-btn mt--15" 
                href={actionButtonLink} 
                target="_blank"> 
                  {actionButtonText}
              </Link>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadCrumb;
